export default 'password-visibility-toggle';
